import { h, Component, createRef } from "preact"

export class GoogleMap extends Component {
  mapRef = createRef()
  map = {}
  markers = []
  lastActives = []
  visibleMarkers = []

  onMarkerClick = (id, type) => {
    this.props.activate(id, type)
  }

  componentDidMount() {
    this.map = new Gmap(this.mapRef.current)
    this.markers = this.map.addMarkers(this.props.markers, this.onMarkerClick)
    this.updateMarkerVisibility()
  }

  updateMarkerVisibility = () => {
    if (this.markers.length > 0) {
      const bounds = new google.maps.LatLngBounds()

      if (
        this.visibleMarkers.length === 0 ||
        this.visibleMarkers[0]?.id !== this.props.visibleMarkers[0]?.id
      ) {
        this.visibleMarkers = []
        this.markers.forEach((m) => {
          if (this.props.visibleMarkers.some((vm) => vm.id === m.id)) {
            m.marker.setVisible(true)
            this.visibleMarkers.push(m)
            bounds.extend(
              new google.maps.LatLng(
                m.marker.position.lat(),
                m.marker.position.lng(),
              ),
            )
          } else {
            m.marker.setVisible(false)
          }
        })

        // reset scope
        if (!bounds.isEmpty()) {
          this.map.map.fitBounds(bounds)
          this.map.map.panToBounds(bounds)
        } else {
          this.map.map.setCenter({
            lat: this.props.scope[0],
            lng: this.props.scope[1],
          })
        }
        this.map.map.setZoom(this.props.scope[2])
      }

      if (
        this.props.actives.every((a) => a.id === undefined) &&
        this.props.initiallyActivateAll
      ) {
        this.visibleMarkers.forEach((m) => {
          this.foregroundMarker(m.marker)
        })

        this.lastActives = this.visibleMarkers.map((m) => {
          return { id: m.id, type: m.type }
        })
      } else {
        this.visibleMarkers
          .filter((m) =>
            this.lastActives.some((a) => a.id === m.id && a.type === m.type),
          )
          .forEach((m) => {
            this.backgroundMarker(m.marker)
          })

        this.visibleMarkers
          .filter((m) =>
            this.props.actives.some((a) => a.id === m.id && a.type === m.type),
          )
          .forEach((m) => {
            this.foregroundMarker(m.marker)
          })

        this.lastActives = this.props.actives
      }
    }
  }

  foregroundMarker(marker) {
    marker.setOpacity(1)
    marker.setZIndex(9999)
  }

  backgroundMarker(marker) {
    marker.setOpacity(0.5)
    marker.setZIndex(1)
  }

  render(props) {
    this.updateMarkerVisibility()
    return <div class={`farmers__map--${props.class}`} ref={this.mapRef} />
  }
}

export class Gmap {
  constructor(_el) {
    this.map = this.initMap(_el)
  }
  initMap(_el) {
    return new google.maps.Map(_el, {
      mapTypeId: google.maps.MapTypeId.TERRAIN,
      scrollwheel: false,
      draggable: true,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#cdcdcd",
            },
            {
              visibility: "on",
            },
            {
              weight: 1,
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "administrative.neighborhood",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
      ],
    })
  }

  addMarkers(markers, onMarkerClick) {
    return markers.map((m) => {
      const iconPath =
        m.type === "locations" ? "4" : m.type === "partners" ? "5" : "0"
      // FIXME stop hardcoding the domain here.
      const icon = `https://blog-admin.gebana.com/static/pesco/marker/phase_${iconPath}.png`
      const marker = new google.maps.Marker({
        opacity: 0.5,
        position: { lat: Number(m.latitude), lng: Number(m.longitude) },
        map: this.map,
        title: "",
        icon,
        visible: false,
      })

      marker.addListener("click", () => onMarkerClick(m.id, m.type))
      return { id: m.id, type: m.type, marker }
    })
  }
}
